import React from 'react'
import {
    Grid,
    makeStyles,
    Button,
    MenuItem,
} from '@material-ui/core';
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch } from 'react-redux';
import { useForm } from '../../../hooks/useForm';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { PARENTESCOS, TIPO_DOCUMENTO } from '../../../utils/constants';
import { modificarFamiliar } from '../../../actions/afiliadoModificacionFam';
import { desSeleccionarAfiliado } from '../../../actions/afiliado';


const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        marginTop: '30px',
        borderRadius: '5px',
        padding: '20px',
    },
    TypographyRoot: {
        marginBottom: 5,

    },
    formControl: {
        marginTop: theme.spacing(2),
    },
    hideButton: {
        display: "none",
    },
    botonera: {
        padding: 25
    },
    formValidator: {
        padding: 10
    }
}))

export const ModificacionAfiliados = (props) => {

    const classes = useStyles()
    const dispatch = useDispatch()

    const formAfiliado = {
        apellido_y_nombre: "",
        carnet: "",
        cuil: "",
        nro_doc: "",
        fecha_alta: "",
        fecha_baja: "",
        id_tipo_documento: "",
        fecha_nacimiento: ""
    }

    const [
        formValues,
        handleInputChange,
        setearValor,
    ] = useForm(props.afiliado ? props.afiliado : formAfiliado);


    // const handleChangeValid = (e) => {
    //     if (e.target.value === TIPO_DOCUMENTO.RN) {
    //         setearValor2(
    //             "fecha_fin_cobertura",
    //             moment(formValues.fecha_nacimiento).add(1, "M"),
    //             "id_tipo_documento",
    //             e.target.value
    //         );
    //     } else {
    //         setearValor2(
    //             "fecha_fin_cobertura",
    //             null,
    //             "id_tipo_documento",
    //             e.target.value
    //         );
    //     }
    // };

    const onSubmit = (e) => {
        e.preventDefault();
        const datos = {
            id_afiliado : formValues.id_afiliado,
            nro_doc : formValues.nro_doc,
            id_tipo_documento: formValues.id_tipo_documento,
            cuil : formValues.cuil
        }
        dispatch(modificarFamiliar(datos));
        dispatch(desSeleccionarAfiliado());
    }


    return (
        <ValidatorForm className={classes.formValidator} onSubmit={onSubmit}>
            <Grid container spacing={2} style={{ padding: 25 }}>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        disabled={true}
                        fullWidth={true}
                        id="standard-disabled"
                        label="Carnet"
                        name="carnet"
                        value={formValues.carnet}
                        autoComplete="off"
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        disabled={true}
                        fullWidth={true}
                        id="standard-disabled"
                        label="Apellido y Nombre"
                        name="apellido_y_nombre"
                        value={formValues.apellido_y_nombre}
                        autoComplete="off"
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <SelectValidator
                        value={formValues.id_tipo_documento || ""}
                        disabled={formValues.id_parentesco === PARENTESCOS.TITULAR ? true : false}
                        label="Tip.Doc"
                        name="id_tipo_documento"
                        validators={["required"]}
                        errorMessages={["Este campo es obligatorio"]}
                        margin="normal"
                        fullWidth={true}
                        onChange={handleInputChange}
                    >
                        <MenuItem value="">
                            <em>Seleccione</em>
                        </MenuItem>
                        <MenuItem value={TIPO_DOCUMENTO.DNI}>DNI</MenuItem>
                        <MenuItem value={TIPO_DOCUMENTO.LIBRETA_ENROLAMIENTO}>
                            LE
                        </MenuItem>
                        <MenuItem value={TIPO_DOCUMENTO.LIBRETA_CIVICA}>LC</MenuItem>
                        <MenuItem value={TIPO_DOCUMENTO.PASAPORTE}>PAS</MenuItem>
                        <MenuItem value={TIPO_DOCUMENTO.NI}>NI</MenuItem>
                        {props.afiliado?.id_parentesco !== PARENTESCOS.TITULAR && (
                            <MenuItem value={TIPO_DOCUMENTO.RN}>RN</MenuItem>
                        )}
                    </SelectValidator>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        fullWidth={true}
                        disabled={formValues.id_parentesco === PARENTESCOS.TITULAR ? true : false}
                        label="DNI"
                        name="nro_doc"
                        validators={[
                            "required",
                            "isNumber",
                            "maxNumber:99999999",
                            "minNumber:9999999",
                        ]}
                        errorMessages={[
                            "El DNI es requerido",
                            "Sólo números",
                            "Verifique DNI ingresado",
                            "Verifique DNI ingresado",
                        ]}
                        value={formValues.nro_doc}
                        onChange={handleInputChange}
                        autoComplete="off"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        fullWidth={true}
                        disabled={formValues.id_parentesco === PARENTESCOS.TITULAR ? true : false}
                        label="CUIL"
                        name="cuil"
                        validators={[
                            "required",
                            "isNumber",
                            "maxNumber:99999999999",
                            "minNumber:9999999999",
                        ]}
                        errorMessages={[
                            "El CUIT es requerido",
                            "Sólo números",
                            "Verifique CUIT ingresado",
                            "Verifique CUIT ingresado",
                        ]}
                        value={formValues.cuil}
                        onChange={handleInputChange}
                        autoComplete="off"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <MuiPickersUtilsProvider
                        locale={esLocale}
                        utils={DateFnsUtils}
                    >
                        <KeyboardDatePicker
                            disableToolbar
                            fullWidth={true}
                            margin="normal"
                            id="fecha_nacimiento"
                            label="Fecha Nacimiento"
                            variant="inline"
                            format="dd/MM/yyyy"
                            disabled={true}
                            maxDate={moment(new Date()).add(3, 'M')}
                            value={
                                moment(formValues.fecha_nacimiento).isValid()
                                    ? moment(formValues.fecha_nacimiento)
                                    : null
                            }
                            onChange={(date) => {
                                setearValor("fecha_nacimiento", date);
                            }}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} md={6}>
                    <MuiPickersUtilsProvider
                        locale={esLocale}
                        utils={DateFnsUtils}
                    >
                        <KeyboardDatePicker
                            disableToolbar
                            fullWidth={true}
                            margin="normal"
                            id="fecha_alta"
                            label="Fecha Alta"
                            variant="inline"
                            format="dd/MM/yyyy"
                            disabled={true}
                            maxDate={moment(new Date()).add(3, 'M')}
                            value={
                                moment(formValues.fecha_alta).isValid()
                                    ? moment(formValues.fecha_alta)
                                    : null
                            }
                            onChange={(date) => {
                                setearValor("fecha_alta", date);
                            }}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} md={6}>
                    <MuiPickersUtilsProvider
                        locale={esLocale}
                        utils={DateFnsUtils}
                    >
                        <KeyboardDatePicker
                            disableToolbar
                            fullWidth={true}
                            margin="normal"
                            id="fecha_baja"
                            label="Fecha Baja"
                            variant="inline"
                            format="dd/MM/yyyy"
                            disabled={true}
                            maxDate={moment(new Date()).add(3, 'M')}
                            value={
                                moment(formValues.fecha_baja).isValid()
                                    ? moment(formValues.fecha_baja)
                                    : null
                            }
                            onChange={(date) => {
                                setearValor("fecha_alta", date);
                            }}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid container className={classes.botonera} >
                    <Grid item sm={8}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={() => {
                                  dispatch(desSeleccionarAfiliado());
                                }}
                            >
                                CANCELAR
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<SaveIcon />}
                                type='submit'
                                style={{ marginLeft: "0.5rem" }}
                            //onClick={props.cerrarModal}
                            >
                                GUARDAR
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm>
    )
}
